import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NavHeaderPanelComponent} from './components/nav-header-panel/nav-header-panel.component';
import {RouterModule} from '@angular/router';

import {SharedModule} from '../shared/shared.module';
import {MaterialModule} from '../material.module';
import {FormsModule} from '@angular/forms';
import { NavProfilePictureComponent } from './components/nav-profile-picture/nav-profile-picture.component';
import { SettingsModalComponent } from './components/settings-modal/settings-modal.component';
import {MatListModule} from '@angular/material/list';
import { RichTextModule } from '../shared/components/rich-text/rich-text.module';


@NgModule({
  declarations: [NavHeaderPanelComponent, NavProfilePictureComponent, SettingsModalComponent],
  exports: [
    NavHeaderPanelComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    MaterialModule,
    FormsModule,
    MatListModule,
    RichTextModule,
  ]
})
export class NavHeaderModule { }
